import { Application } from "@hotwired/stimulus"
import AccordionController from "@kanety/stimulus-accordion"

const application = Application.start()
application.register("accordion", AccordionController)

export default class extends AccordionController {}
